import { TrancheOrder } from '../models/tranche-order';

const NO_ORDERS_FOR_SELECTED_TRANCHE = 'No Orders for Selection';
const NO_ORDERS_FOR_FILTERED_SELECTED_TRANCHE =
  'No Results for Selection and Filter Options';

const hasTrancheOrders = (orders: TrancheOrder[]): boolean =>
  orders && orders.length > 0;

/**
 * Returns empty message for tranche order table with orders,
 * and empty messages for other cases depending whether filter is applied or not.
 *
 * @param orders
 * @param isFiltered
 * @returns string
 */
export function emptyMessageMapper(
  orders: TrancheOrder[],
  isFiltered: boolean
): string {
  if (hasTrancheOrders(orders)) {
    return undefined;
  } else if (isFiltered) {
    return NO_ORDERS_FOR_FILTERED_SELECTED_TRANCHE;
  }

  return NO_ORDERS_FOR_SELECTED_TRANCHE;
}
